import React, { useMemo } from 'react'
import View from './view.js'
import format from 'date-fns/format'

export default function Logic(props) {
  let text = useMemo(() => format(props.month, 'MMM yyyy'), [props.month])
  return <View {...props} text={text} />
}
